import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { carouselData } from "../data/Data";
import Popup from "./popup";
import { Link } from "react-router-dom";

export default function Carousel() {
  const sliderRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnHover: true,
    arrows: false, // no slick arrows
  };

  const handleButtonClick = (action, event) => {
    event.preventDefault();
    if (action === "showPopup") setShowPopup(true);
  };

  return (
    <>
      {/* pulled up so it touches navbar */}
      <div
        className="container-fluid p-0 m-0 position-relative"
        id="header-carousel"
      >
        <Slider ref={sliderRef} {...settings}>
          {carouselData.map((val, index) => {
            const webpUrl = val.img.replace(/\.jpg$/, ".webp");
            return (
              <div className="carousel-item" key={index}>
                <picture>
                  <source srcSet={webpUrl} type="image/webp" />
                  <img
                    className="w-100"
                    src={val.img}
                    alt={val.title}
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchpriority={index === 0 ? "high" : "low"}
                  />
                </picture>
                <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                  <div className="p-3" style={{ maxWidth: "700px" }}>
                    <h6 className="section-title text-white text-uppercase mb-3 animated fadeInDown">
                      {val.subtitle}
                    </h6>
                    <h2 className="display-3 text-white mb-4 animated fadeInUp">
                      {val.title}
                    </h2>
                    <div className="d-flex justify-content-center gap-3 flex-nowrap buttons-row">
                    {/* CRAZY primary button */}
                    <Link
                      to={val.btn1Link}
                      className="btn hk-hero-btn-primary py-3 px-4 rounded-pill shadow-lg animated fadeInLeft"
                    >
                      {val.btn1}
                    </Link>

                    {/* CRAZY outline / glass button */}
                    <button
                      className="btn hk-hero-btn-outline py-3 px-4 rounded-pill shadow-lg animated fadeInRight"
                      onClick={(e) => handleButtonClick("showPopup", e)}
                    >
                      {val.btn2}
                    </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>

        {/* NOTE: custom < and > buttons removed as requested */}
      </div>

      {showPopup && (
        <Popup show={showPopup} onClose={() => setShowPopup(false)} />
      )}

      <style>{`
        .slick-dots {
          display: none !important;
        }

        /* Pull hero up so image touches top edge of screen */
        #header-carousel {
          position: relative;
          overflow: hidden;
          margin-top: -115px !important;
          padding-top: 0 !important;
          background-color: #050E1A;
        }

        @media (max-width: 991px) {
          #header-carousel {
            margin-top: -95px !important;
          }
        }

        @media (max-width: 575px) {
          #header-carousel {
            margin-top: -85px !important;
          }
        }

        /* Carousel items */
        .carousel-item {
          position: relative;
          height: 100vh;
          background-color: #000;
          overflow: hidden;
        }

        .carousel-item img {
          width: 100%;
          height: 100vh;
          object-fit: cover;
          filter: brightness(0.78);
          transition: transform 8s ease-in-out;
        }

        /* Smooth zoom animation when active */
        .slick-active .carousel-item img {
          transform: scale(1.08);
        }

        /* Caption overlay */
        .carousel-caption {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          padding-top: 130px !important;
          background: radial-gradient(circle, rgba(15, 23, 43, 0.42) 0%, rgba(5, 14, 26, 0.58) 100%);
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }

        .carousel-caption .p-3 {
          max-width: 700px;
        }

        .carousel-caption h6 {
          font-size: 1.1rem;
          letter-spacing: 2px;
          color: #fff;
          font-weight: 500;
          margin-bottom: 1rem;
          text-transform: uppercase;
        }

        .carousel-caption h1 {
          font-size: 3rem;
          color: #fff;
          font-weight: 700;
          margin-bottom: 1.5rem;
          line-height: 1.1;
        }

        /* Shared button base in hero */
        .carousel-caption .btn {
          font-size: 1rem;
          padding: 0.75rem 2rem;
          border-radius: 50px;
          transition: all 0.3s ease-in-out;
          white-space: nowrap;
          flex-shrink: 1;
          min-width: 120px;
          text-align: center;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        /* ROYAL PRIMARY – Saffron/Gold */
        .hk-hero-btn-primary {
          background: linear-gradient(135deg, #FEA116, #D4AF37);
          color: #050E1A;
          border: 1.5px solid rgba(255, 255, 255, 0.5);
          box-shadow: 0 10px 28px rgba(254, 161, 22, 0.4);
          font-weight: 700;
        }

        .hk-hero-btn-primary:hover,
        .hk-hero-btn-primary:focus {
          background: linear-gradient(135deg, #ff8c00, #fea116);
          border-color: rgba(255, 255, 255, 0.8);
          box-shadow: 0 14px 32px rgba(254, 161, 22, 0.6);
          color: #050E1A;
          transform: translateY(-2px);
          outline: none;
        }

        /* ROYAL OUTLINE / GLASS for Book Room */
        .hk-hero-btn-outline {
          background: rgba(255, 255, 255, 0.1);
          border: 1.5px solid rgba(255, 255, 255, 0.6);
          color: #ffffff;
          box-shadow: 0 10px 26px rgba(0, 0, 0, 0.2);
          font-weight: 600;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
        }

        .hk-hero-btn-outline:hover,
        .hk-hero-btn-outline:focus {
          background: #ffffff;
          color: #0B1D37;
          border-color: #ffffff;
          box-shadow: 0 14px 28px rgba(255, 255, 255, 0.35);
          transform: translateY(-2px);
          outline: none;
        }

        /* Responsive Styling */
        @media (max-width: 1024px) {
          .carousel-item {
            height: 70vh;
          }
          .carousel-item img {
            height: 70vh;
          }
          .carousel-caption h1 {
            font-size: 2.5rem;
          }
          .carousel-caption h6 {
            font-size: 1rem;
          }
          .carousel-caption .btn {
            font-size: 0.95rem;
            padding: 0.6rem 1.5rem;
            min-width: 110px;
          }
        }

        @media (max-width: 768px) {
          .carousel-item {
            min-height: 85vh !important;
            height: auto !important;
          }
          .carousel-item img {
            min-height: 85vh !important;
            height: auto !important;
          }
          .carousel-caption {
            padding-top: 130px !important; /* shift content down below the fixed navbar */
            padding-bottom: 90px !important; /* reserve bottom padding for overlap */
            display: flex !important;
            flex-direction: column !important;
            justify-content: center !important;
            align-items: center !important;
          }
          .carousel-caption h2 {
            font-size: 2.1rem !important;
            line-height: 1.2 !important;
            margin-bottom: 15px !important;
            font-weight: 700 !important;
          }
          .carousel-caption h6 {
            font-size: 0.95rem !important;
            letter-spacing: 2px !important;
            margin-bottom: 10px !important;
          }
          .carousel-caption .btn {
            font-size: 0.85rem !important;
            padding: 0.55rem 1.25rem !important;
            min-width: 100px !important;
          }
          .slick-dots {
            display: none !important;
          }

          /* Buttons: keep nowrap, adjust gap */
          .carousel-caption .buttons-row {
            flex-wrap: nowrap !important;
            justify-content: center;
            gap: 8px !important;
            margin-top: 12px !important;
          }
        }

        @media (max-width: 400px) {
          .carousel-caption .btn {
            font-size: 0.75rem;
            padding: 0.4rem 1rem;
            min-width: 90px;
          }
          .carousel-caption .buttons-row {
            flex-wrap: nowrap !important;
            gap: 6px;
          }
        }

        @media (max-width: 360px) {
          .carousel-caption .btn {
            font-size: 0.7rem;
            padding: 0.35rem 0.9rem;
            min-width: 80px;
          }
          .carousel-caption .buttons-row {
            flex-wrap: nowrap !important;
            gap: 5px;
          }
        }
      `}</style>
    </>
  );
}
